import React from "react";
import { Link } from "react-router";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import type { HealthCauseVm, HealthCausesVm } from "@/features/daily/components/command/health-view-model";

const CauseList: React.FC<{ causes: HealthCauseVm[]; label: string; titled?: boolean }> = ({ causes, label, titled = true }) => (
    <>
        {titled ? <p className="daily-causes__title">{label} ({causes.length})</p> : null}
        <ul className="daily-causes" aria-label={label}>
            {causes.map((cause) => (
                <li key={cause.key} className="daily-cause" data-tone={cause.tone}>
                    <span className="daily-cause__text">{cause.text}</span>
                    <Link className="daily-link" to={cause.href}>
                        Ver operaciones <DailyIcon name="arrow_forward" />
                    </Link>
                    <span className="daily-cause__normal">
                        <strong>Cómo volver a la normalidad:</strong> {cause.normalization}
                    </span>
                </li>
            ))}
        </ul>
    </>
);

/**
 * D117/B10 + Guardian P1: what is behind the state, grouped by what the server says
 * about each cause — only `within_target` may read «dentro de objetivo», and it stays
 * collapsed. Each cause keeps its population link and the way back to normal.
 */
export const HealthCauses: React.FC<{ causes: HealthCausesVm }> = ({ causes }) => (
    <div className="daily-causes-block">
        {causes.affecting.length === 0 ? null : <CauseList causes={causes.affecting} label="Afecta al estado" />}
        {causes.warnings.length === 0 ? null : <CauseList causes={causes.warnings} label="Avisos" />}
        {causes.informative.length === 0 ? null : <CauseList causes={causes.informative} label="Informativo" />}
        {causes.withinTarget.length === 0 ? null : (
            <details className="daily-causes-checked">
                <summary>Dentro de objetivo ({causes.withinTarget.length})</summary>
                <CauseList causes={causes.withinTarget} label="Dentro de objetivo" titled={false} />
            </details>
        )}
    </div>
);
